module.exports = __webpack_public_path__ + "fonts/trust_sans_medium_it-webfont.5cc32b34.woff2";